/**
 * Actions for Task Risk Analysis translation requests
 *
 * @author Robbe De Geyndt <robbe.degeyndt@aware.be>
 */

'use strict';

//imports
import APIAction from './APIAction';
import {toast} from 'react-hot-toast';
import T from './TranslationAction';

//define class
let TranslationRequestAction = {

    /**
     * Request a translated PDF for a Task Risk Analysis
     *
     * @param {*} taskRiskAnalysisId
     * @param {*} languageCode
     */
    requestTranslation: async function(taskRiskAnalysisId, languageCode) {

        //set data
        let data = {
            task_risk_analysis_id: taskRiskAnalysisId,
            language: languageCode
        };

        //call
        let result = await APIAction.request('/task_risk_analysis_translation_requests', 'POST', true, data);

        //check if result is valid
        if (result && 'id' in result) {
            let message = await T.translate('KEY.Translation requested');
            toast.success(message);
        } else {
            let message = await T.translate('KEY.Could not request translation');
            toast.error(message);
        }

        //return
        return result;
    },

    /**
     * List translation requests for a Task Risk Analysis
     *
     * @param {*} taskRiskAnalysisId
     */
    getTranslationRequests: async function(taskRiskAnalysisId) {

        //call
        let result = await APIAction.request('/task_risk_analysis_translation_requests', 'GET', true, {
            task_risk_analysis_id: taskRiskAnalysisId
        });

        //guard against non-array responses (e.g. an error payload from a backend
        //that doesn't have this endpoint yet, or any other API-level error)
        return Array.isArray(result) ? result : [];
    },

    /**
     * Accept or reject a pending translation request
     *
     * @param {*} requestId
     * @param {*} accept
     */
    respondToTranslationRequest: async function(requestId, accept) {

        //call
        let result = await APIAction.request('/task_risk_analysis_translation_requests/' + requestId + '/' + (accept ? 'accept' : 'reject'), 'PATCH', true, {});

        //show toast
        let message = await T.translate(accept ? 'KEY.Translation request accepted' : 'KEY.Translation request rejected');
        toast.success(message);

        //return
        return result;
    },

    /**
     * List completed/available translations for a Task Risk Analysis
     *
     * @param {*} taskRiskAnalysisId
     */
    getTranslations: async function(taskRiskAnalysisId) {

        //call
        let result = await APIAction.request('/task_risk_analysis_translations', 'GET', true, {
            task_risk_analysis_id: taskRiskAnalysisId
        });

        //guard against non-array responses (e.g. an error payload from a backend
        //that doesn't have this endpoint yet, or any other API-level error)
        return Array.isArray(result) ? result : [];
    }
};

//export
export default TranslationRequestAction;
